module.exports = "/static/media/desktop.2c22edc3.svg";